import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth-service/auth.service';
import { loadStripe, StripeCardElement } from '@stripe/stripe-js';
import { PaymentService } from 'src/app/services/payment-service/payment.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit {

  
  //totalStorage = 128 * 1024 * 1024 * 1024; // 128 Go
  totalStorage = 0;
  usedsize = 0;
  filsize = 0;
  blocsize = 0;
  packname = 'free';

  photos = 80.43 * 1024 * 1024 * 1024;
  apps = 20 * 1024 * 1024 * 1024;
  icloud = 5 * 1024 * 1024 * 1024;
  ios = 10 * 1024 * 1024 * 1024;
  system = 12.27 * 1024 * 1024 * 1024;
  dataStat = [];

  stripe: any;
      card: StripeCardElement | null = null;
      packType : string;
      userCount = 0;
      totalAmount = 0;
      currentUser = null;
      admin = false;
      type = 0;
      currentPack = 'free';
      //stripePromise = loadStripe('pk_test_51R22BxFLfoFgeSiXZVsLtVJUAafwuz7gp8mpfMrQcQdwG3B4T19cGBZ5fINZ19p28UuppWRpX8SDmB7RPPTfLeXo00t0Hnd534');
      stripePromise = loadStripe('pk_test_51Rj76AFqvuHDQiWGVi0V6eYzGfuLWQqniCOdGeDPRxMWkZWF4Thl03kGfSgDiT9XYkNdJsDGfbOwHScvFGeBFtMy00d3nFJfLU');
      //pk_test_51R22CFFS8kUFVqJj4cE66DnsTM1xsCqvOPSU1mOCpySLeQRospuLJUmpPl1B0RZgtsYyOEdMJiwBC3BTvFWaqm5Y00OA1aOX3Z
      packOrder = ['starter', 'basic', 'medium', 'pro', 'gold'];
      storageLimits: { [key: string]: number } = {
        starter: 5,
        basic: 10,
        medium: 25,
        pro: 50,
        gold: 100
      };
  
      amountNow: number | null = null;
      amountMonthly: number | null = null;
      selectedPack: string = 'gold';
      showPopup = false;
      loading = false;

  constructor(private paymentService: PaymentService, private authService: AuthService, private router: Router) { 
    this.type = 2;
    this.currentPack = "pro";
  }

  ngOnInit() {
    this.getStorage();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.admin = this.currentUser.roles.includes('ROLE_MANAGER');
    this.getCurrentCompany();
    this.authService.getCountAllContacts()
      .subscribe(res => {
        this.userCount = res['userCount'];
        this.totalAmount = this.userCount * 2.99;
      })
  }

  

  getStorage(){
    this.authService.getStorage().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.dataStat = [{
        libelle: "Total",
        chiffre: dataArray.totalsize
      },
      {
        libelle: "Espace Utilisé",
        chiffre: dataArray.usedsize
      },
      {
        libelle: "Fichiers Fils",
        chiffre: dataArray.filsize
      },
      {
        libelle: "Fichiers Blocs",
        chiffre: dataArray.blocsize
      },
    ]; 
    this.totalStorage = dataArray.totalsize;
    this.usedsize = dataArray.usedsize;
    this.blocsize = dataArray.blocsize;
    this.filsize = dataArray.filsize;
    this.packname = dataArray.packname;
    this.details = [
      { name: 'Stockage utlisé', size: this.usedsize, class: 'photos' },
      { name: 'Stockage Espace Fil', size: this.filsize, class: 'fil' },
      { name: 'Stockage Espace Bloc', size: this.blocsize, class: 'bloc' },
    ];
       
    },
    (error) => {
      alert('Erreur ! : ' + error)
    });
  }

  get totalUsed() {
    return this.dataStat[0].chiffre;
    return this.photos + this.apps + this.icloud + this.ios + this.system;
  }

  getPercent(value: number): number {
    return (value / this.totalStorage) * 100;
  }

  formatSize(bytes: number): string {
    const gb = bytes / (1024 * 1024 * 1024);
    return gb.toFixed(2) + ' Go';
  }

  formatSizeInt(bytes: number): string {
    const gb = bytes / (1024 * 1024 * 1024);
    return gb.toFixed(0) + ' Go';
  }

  details = [];
  

  getCurrentCompany(){
    var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
     this.authService.getInfoCompany(idcompany)
     .subscribe( data => {
        this.currentPack  = data['subscriptionPack'];
     }, (error) => {
     });
 
  }

  isDisabled(packName: string): boolean {
    const currentIndex = this.packOrder.indexOf(this.currentPack);
    const selectedIndex = this.packOrder.indexOf(packName);

    if (this.type === 1) {
      // Limite de stockage atteinte → Interdire pack identique ou inférieur
      return selectedIndex <= currentIndex;
    }

    if (this.type === 2) {
      // Abonnement expiré → Interdire pack inférieur
      return selectedIndex <= currentIndex;
    }

    return false;
  }

  getCurrentStorageLimit(): string {
    const limit = this.storageLimits[this.currentPack];
    return limit ? `${limit} Go` : '200 Mo'; // fallback au cas où
  }

  logout() {
    //console.log('logging out header');
    this.authService.logout();
  }

  async checkout(packType: string) {
    const stripe = await this.stripePromise;
    //const { token, error } = await this.stripe.createToken(this.card);
    this.paymentService.upgradeCheckoutSession({ packType: this.selectedPack }).subscribe(response => {
      if (response.status === 'success') {
        // Mise à jour UI
        this.currentPack = response.currentPack;
        alert(`Upgrade vers ${response.currentPack} réussi !`);
        this.router.navigate(['/payment-success']);
      }
    });
  }

  async onUpgradeClick2(packType: string) {
    const stripe = await this.stripePromise;
    //const { token, error } = await this.stripe.createToken(this.card);
    this.paymentService.createCheckoutSession({ packType: packType }).subscribe(async session => {
      if (stripe) {
        await stripe.redirectToCheckout({ sessionId: session.id });
      }
    });
  }

  onUpgradeClick(packType: string) {
    this.loading = true;
    this.selectedPack = packType;
    this.paymentService.getUpgradePreview({ packType: packType }).subscribe({
      next: (res) => {
        this.amountNow = res.amountNow / 100; // Stripe renvoie en cents
        this.amountMonthly = res.amountMonthly / 100;
        this.showPopup = true;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this.selectedPack = null;
      }
    });
  }

  onCancel() {
    this.showPopup = false;
    this.selectedPack = null;
  }

  pay(packType: string) {
    //this.openPaymentDialog(packType); // Ouvre le dialogue avec le pack sélectionné
  }





}
